import React from 'react'
import ruepaix from "../assets/lieu/8ruepaix.png";
import arthe from "../assets/lieu/arthe.png";

const Cours = () => {
  return (
    <section id="cours" className="relative py-20 bg-gradient-to-br from-white via-gray-50 to-white overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-primary/5 to-red-100/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-red-50/30 to-primary/5 rounded-full blur-3xl"></div>
      
      <div className="relative container mx-auto px-6 lg:px-8">
        {/* En-tête de section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Nos cours
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Deux <span className="text-primary">lieux</span> d'entraînement
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Des installations modernes et adaptées pour tous les niveaux.
          </p>
        </div>

        {/* Grille des lieux */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-7xl mx-auto">
          
          {/* Lieu 1 - Gymnase COSEC */}
          <div className="group">
            <div className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 p-8">
              {/* En-tête du lieu */}
              <div className="text-center mb-8">
                <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm font-semibold rounded-full mb-4">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                  </svg>
                  Lieu principal
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Gymnase du COSEC</h3>
                <p className="text-gray-600">8 rue de la paix, Ceyrat</p>
              </div>

              {/* Image du lieu */}
              <div className="relative mb-8 overflow-hidden rounded-2xl">
                <a
                  href="https://www.openstreetmap.org/note/new?lat=45.73398&lon=3.06692#map=16/45.7334/3.0709&layers=N"
                  target="_blank"
                  rel="noreferrer"
                  className="block group-hover:scale-105 transition-transform duration-500"
                >
                  <img
                    src={ruepaix}
                    className="w-full h-64 object-cover"
                    alt="Gymnase du COSEC - 8 rue de la paix"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-4 left-4 text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Voir sur la carte
                  </div>
                </a>
              </div>

              {/* Programme des cours */}
              <div className="space-y-6">
                <div className="bg-gray-50 rounded-2xl p-6">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-3 h-3 bg-primary rounded-full"></div>
                    <h4 className="text-lg font-bold text-gray-900">Karaté Adulte</h4>
                  </div>
                  <div className="space-y-2 text-gray-600">
                    <div className="flex items-center space-x-2">
                      <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <span>Lundi 20h - 21h30</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <span>Jeudi 18h30 - 20h</span>
                    </div>
                  </div>
                </div>

                <div className="bg-yellow-50 rounded-2xl p-6">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                    <h4 className="text-lg font-bold text-gray-900">Préparation aux grades</h4>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <svg className="w-4 h-4 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span>Lundi 19h - 20h</span>
                  </div>
                </div>

                <div className="bg-green-50 rounded-2xl p-6">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <h4 className="text-lg font-bold text-gray-900">Renforcement musculaire</h4>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span>Vendredi 19h15 - 20h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Lieu 2 - Artenium */}
          <div className="group">
            <div className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 p-8">
              {/* En-tête du lieu */}
              <div className="text-center mb-8">
                <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-purple-500 to-purple-600 text-white text-sm font-semibold rounded-full mb-4">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
                  </svg>
                  Centre moderne
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Artenium</h3>
                <p className="text-gray-600">4 parc de l'artière, Ceyrat</p>
              </div>

              {/* Image du lieu */}
              <div className="relative mb-8 overflow-hidden rounded-2xl">
                <a
                  href="https://www.openstreetmap.org/note/new?lat=45.73542&lon=3.06914#map=17/45.73437/3.06903&layers=N"
                  target="_blank"
                  rel="noreferrer"
                  className="block group-hover:scale-105 transition-transform duration-500"
                >
                  <img
                    src={arthe}
                    className="w-full h-64 object-cover"
                    alt="Artenium - 4 parc de l'artière"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-4 left-4 text-white font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Voir sur la carte
                  </div>
                </a>
              </div>

              {/* Programme des cours */}
              <div className="space-y-6">
                <div className="bg-red-50 rounded-2xl p-6">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-3 h-3 bg-primary rounded-full"></div>
                    <h4 className="text-lg font-bold text-gray-900">Self-Défense</h4>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-600">
                    <svg className="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span>Mercredi 19h30 - 21h</span>
                  </div>
                </div>

                <div className="bg-blue-50 rounded-2xl p-6">
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                    <h4 className="text-lg font-bold text-gray-900">Karaté Enfants</h4>
                  </div>
                  <div className="space-y-3 text-gray-600">
                    <div className="flex items-start space-x-2">
                      <svg className="w-4 h-4 text-blue-500 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                      <div>
                        <div className="font-medium text-gray-900">Mercredi 18h - 18h45</div>
                        <div className="text-sm">Cours collectifs (45min) - À partir de 8 ans</div>
                      </div>
                    </div>
                    <div className="flex items-start space-x-2">
                      <svg className="w-4 h-4 text-blue-500 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                      </svg>
                      <div>
                        <div className="font-medium text-gray-900">Mercredi 18h45 - 19h15</div>
                        <div className="text-sm">Cours avancés optionnels (30min) - À la suite, pour les élèves motivés</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section informations complémentaires */}
        <div className="mt-16 bg-white rounded-3xl shadow-xl p-6 md:p-8 border border-gray-100">
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Informations pratiques</h3>
            <p className="text-gray-600">Tout ce qu'il faut savoir pour bien commencer</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Cours d'essai gratuit</h4>
              <p className="text-xs md:text-sm text-gray-600">Venez découvrir nos cours</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Matériel</h4>
              <p className="text-xs md:text-sm text-gray-600">Équipements, poids, etc</p>
            </div>
            
            <div className="text-center col-span-2 md:col-span-1">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-gray-900 mb-1 md:mb-2">Tous niveaux</h4>
              <p className="text-xs md:text-sm text-gray-600">Débutants et confirmés sont les bienvenus</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Cours